<template>
  <div class="record">
    <div class="live-list">
      <div class="live-card" v-for="(item,index) in lives" :key="index" @click="handleLiveClick(item.id)">
        <div class="live-logo">
          <img :src="item.cover || defaultImg" alt="logo"/>
        </div>
        <div class="live-info">
          <h4>{{item.name}}</h4>
          <div class="live-status"
               :class="{'status-live': item.status === 1,'status-wait':item.status === 0,'status-end':item.status === 2 }">
            <span class="status-dot"></span>
            <span>{{item.status === 0 ? '未开播' : item.status === 1 ? '直播中' : item.status === 2 ? '已结束' : ''}}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 直播中/未开播：显示 iframe -->
    <div v-if="showLiveIframe && liveStatus !== 2" class="live-iframe-container">
      <div class="iframe-header">
        <h3>{{ currentLiveTitle }}</h3>
        <button class="close-btn" @click="closeLivePlayer">× 关闭</button>
      </div>
      <iframe
          :src="currentLiveUrl"
          frameborder="0"
          class="live-iframe"
          allowfullscreen
      ></iframe>
    </div>

    <!-- 已结束：显示视频播放器 -->
    <div v-if="showLiveIframe && liveStatus === 2" class="video-container">
      <div class="video-header">
        <h3>{{ currentLiveTitle }}</h3>
        <button class="close-btn" @click="closeLivePlayer">× 关闭</button>
      </div>
      <!-- 🔥 修复：添加完整控件属性 + 样式保证显示 -->
      <video
          class="live-video"
          controls
          controlslist="nodownload noplaybackrate"
          disablePictureInPicture
          autoplay
          :src="currentVideoUrl"
          style="width:100%;height:50%;object-fit:contain;background:#000;"
      ></video>
    </div>

    <div class="page" v-if="total > 0">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import {livesList, livesInfo} from '@/api/api'

  export default {
    name: "index",
    data() {
      return {
        defaultImg: require('@/assets/defaultImg.png'),
        lives: [],
        page: 1,
        limit: 10,
        total: 0,
        name: '',
        // 控制播放器显示/隐藏
        showLiveIframe: false,
        // 直播地址
        currentLiveUrl: "",
        // 视频地址（已结束使用）
        currentVideoUrl: "",
        // 当前直播标题
        currentLiveTitle: "",
        // 当前直播状态 0-未开播 1-直播中 2-已结束
        liveStatus: 0
      }
    },
    mounted() {
      this.livesList()
    },
    methods: {
      // 搜索
      handleSearch(data) {
        this.page = 1
        this.name = data
        this.livesList()
      },
      handleSizeChange(val) {
        this.limit = val
        this.livesList()
      },
      handleCurrentChange(val) {
        this.page = val
        this.livesList()
      },
      livesList() {
        let params = {
          page: this.page,
          limit: this.limit,
          name: this.name,
        }
        livesList(params).then(res => {
          this.lives = res.data.list
          this.total = res.data.page.total
        })
      },
      // 直播/回放详情
      // 直播/回放详情
      handleLiveClick(id) {
        livesInfo(id).then(res => {
          // 存储当前直播状态
          this.liveStatus = res.data.status

          if (res.data.status === 2) {
            // 已结束：赋值视频地址
            this.currentVideoUrl = res.data.video_url
          } else {
            // 未开播/直播中：赋值直播iframe地址
            if (res.data.url.startsWith("https://")) {
              this.currentLiveUrl = res.data.url;
            } else if (res.data.url.startsWith("http://")) {
              this.currentLiveUrl = res.data.url;
            }
          }

          this.currentLiveTitle = res.data.name;
          this.showLiveIframe = true;

          // 🔥 修复滚动代码（无语法报错）
          this.$nextTick(() => {
            let dom;
            if (this.liveStatus === 2) {
              dom = document.querySelector(".video-container");
            } else {
              dom = document.querySelector(".live-iframe-container");
            }
            if (dom) {
              dom.scrollIntoView({behavior: "smooth"});
            }
          })
        })
      },
      /**
       * 关闭播放器，统一关闭方法
       */
      closeLivePlayer() {
        this.showLiveIframe = false;
        this.currentLiveUrl = "";
        this.currentVideoUrl = "";
        this.currentLiveTitle = "";
        this.liveStatus = 0;
      },
    }
  }
</script>

<style scoped lang="less">
  // ================= 直播课列表 对齐优化 =================
  .live-list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  }

  .live-card {
    background-color: #fff;
    border-radius: 12px;
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 12px;
    cursor: pointer;
    transition: all 0.3s;
    border: 1px solid #f1f1f1;
  }

  .live-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .live-logo {
    width: 44px;
    height: 44px;
    border-radius: 8px;
    overflow: hidden;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .live-info {
    flex: 1;
  }

  .live-info h4 {
    margin: 0 0 6px 0;
    font-size: 14px;
    font-weight: 500;
    color: #1e293b;
    text-align: left;
  }

  .live-status {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
  }

  .status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }

  .status-live {
    color: #22c55e;

    .status-dot {
      background-color: #22c55e;
    }
  }

  .status-wait {
    color: #ef4444;

    .status-dot {
      background-color: #ef4444;
    }
  }

  .status-end {
    color: #94a3b8;

    .status-dot {
      background-color: #94a3b8;
    }
  }

  /* 🔥 iframe 直播容器样式 */
  .live-iframe-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: #fff;
    z-index: 9999;
    display: flex;
    flex-direction: column;

    .iframe-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 16px;
      background: #2f54eb;
      color: #fff;
      flex-shrink: 0;
      height: 56px;
      box-sizing: border-box;
    }

    .iframe-header h3 {
      margin: 0;
      font-size: 16px;
      font-weight: 500;
    }


    .live-iframe {
      width: 100%;
      flex: 1;
      border: none;
    }
  }

  .close-btn {
    padding: 6px 12px;
    background: #fff;
    color: #2f54eb;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.3s;
  }

  .close-btn:hover {
    background: #f0f0f0;
  }

  /* 🔥 视频播放器样式（已结束使用） */
  .video-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: #000;
    z-index: 9999;
    display: flex;
    flex-direction: column;

    .video-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 16px;
      background: #2f54eb;
      color: #fff;
      flex-shrink: 0;
      height: 56px;
      box-sizing: border-box;
    }

    .video-header h3 {
      margin: 0;
      font-size: 16px;
      font-weight: 500;
    }

    .live-video {
      width: 100%;
      height: 100%;
      flex: 1;
      outline: none;
      object-fit: contain;
      background-color: #000;
      /* 强制显示控制器不自动隐藏 */

      video::-webkit-media-controls-panel {
        opacity: 1 !important;
        display: flex !important;
      }
    }
  }
</style>
